"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTransaction = void 0;
const nearAPI = __importStar(require("near-api-js"));
const currencies_1 = require("../../currencies");
const api_1 = require("./api");
const logic_1 = require("./logic");
const buildTransaction = (a, t, publicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const { nonce, block_hash } = yield (0, api_1.getAccessKey)({
        address: a.freshAddress,
        publicKey,
    });
    const currency = (0, currencies_1.getCryptoCurrencyById)("near");
    const formattedAmount = (0, currencies_1.formatCurrencyUnit)(currency.units[0], t.amount, {
        disableRounding: true,
        showAllDigits: true,
    });
    const parsedNearAmount = nearAPI.utils.format.parseNearAmount(formattedAmount);
    const actions = [];
    switch (t.mode) {
        case "stake":
            actions.push(nearAPI.transactions.functionCall("deposit_and_stake", {}, (0, logic_1.getStakingGas)().toNumber(), parsedNearAmount));
            break;
        case "unstake":
            if (t.useAllAmount) {
                actions.push(nearAPI.transactions.functionCall("unstake_all", {}, (0, logic_1.getStakingGas)().toNumber(), "0"));
            }
            else {
                actions.push(nearAPI.transactions.functionCall("unstake", { amount: parsedNearAmount }, (0, logic_1.getStakingGas)().toNumber(), "0"));
            }
            break;
        case "withdraw":
            if (t.useAllAmount) {
                actions.push(nearAPI.transactions.functionCall("withdraw_all", {}, (0, logic_1.getStakingGas)(t).toNumber(), "0"));
            }
            else {
                actions.push(nearAPI.transactions.functionCall("withdraw", { amount: parsedNearAmount }, (0, logic_1.getStakingGas)().toNumber(), "0"));
            }
            break;
        default:
            actions.push(nearAPI.transactions.transfer(parsedNearAmount));
    }
    const transaction = nearAPI.transactions.createTransaction(a.freshAddress, nearAPI.utils.PublicKey.fromString(publicKey), t.recipient, nonce + 1, actions, nearAPI.utils.serialize.base_decode(block_hash));
    return transaction;
});
exports.buildTransaction = buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map